import { render, staticRenderFns } from "./StatisticHrFeedTable.vue?vue&type=template&id=40b4f74e"
import script from "./StatisticHrFeedTable.vue?vue&type=script&lang=js"
export * from "./StatisticHrFeedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports